import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { WalletErrorType } from '../types/WalletErrorType'

export default class WalletError extends BaseError<WalletErrorType> {
  constructor(
    public message: string,
    public code: WalletErrorType,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, WalletError.prototype)
    this.name = this.constructor.name
  }
}
